// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper_ZMvKW","namespaceBackplate":"styles_namespaceBackplate_NLcwA"};